import { AddSelectedFiltersFunctionType } from 'core/multiple-search/redux/types';
import { TFunction } from 'i18next';
import React, { Component } from 'react';
import InputComponent from '../input/input-container';
import SelectComponent from '../select/select-container';
import DateInputWrapper from './DateInputWrapper';
import MultiselectWrapper from './MultiselectWrapper';

export type FieldDataType = {
  type: string;
  name: string;
  listValues: string[];
  currentValue: any;
  tooltipText: any;
  translateList?: boolean;
  dateKey?: string;
  inputDisabled?: boolean;
  removeLabel?: boolean;
}

interface FieldProps {
  t: TFunction;
  addSelectedFilters: AddSelectedFiltersFunctionType
  id: string;
  fieldData: FieldDataType
  i18nKey?: string;
  displayEmpty?: boolean
  onEnter?: () => void;
}

export default class FieldComponent extends Component<FieldProps, { clicked: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = {
      clicked: false
    };
  }
  render() {
    const { t, addSelectedFilters, fieldData, id, i18nKey, displayEmpty = true } = this.props;

    return (
      <div onClick={() => {this.setState({ ...this.state, clicked: true })}}>
        {fieldData && (fieldData.type === 'text' || fieldData.type === 'number') && (
          <InputComponent
            inputData={{
              name: fieldData.name,
              currentValue: fieldData.currentValue,
              type: fieldData.type,
              tooltipText: fieldData.tooltipText,
              removeLabel: fieldData.removeLabel
            }}
            inputDisabled={fieldData.inputDisabled}
            id={id}
            i18nKey={i18nKey}
            onEnter={this.props.onEnter}
          />
        )}

        {fieldData && fieldData.type === 'list' && (
          <SelectComponent
            selectData={{
              name: fieldData.name,
              listValues: fieldData.listValues,
              currentValue: fieldData.currentValue,
              tooltipText: fieldData.tooltipText,
              translateList: fieldData.translateList,
              removeLabel: fieldData.removeLabel
            }}
            id={id}
            i18nKey={i18nKey}
            displayEmpty={displayEmpty}
          />
        )}

        {fieldData && fieldData.type === 'check' && (
          <div className="has-checkbox checkbox">
            <input
              className="is-small"
              type="checkbox"
              name={t(fieldData.name)}
              onChange={() =>
                addSelectedFilters(id, fieldData.name, 'nagraEmmPlayoutStatus', 'check')
              }
              checked={fieldData.currentValue}
            />
            <label>{t(`${i18nKey || 'datagrabber'}.field_${fieldData.name}`)}</label>
          </div>
        )}

        {fieldData && fieldData.type === 'date' && (
          <DateInputWrapper 
            addSelectedFilters={addSelectedFilters}
            fieldData={fieldData}
            id={id}
          />
        )}

        {fieldData?.type === 'multiselect' && (
          <MultiselectWrapper
            addSelectedFilters={addSelectedFilters}
            fieldData={fieldData}
            id={id}
          />
        )}
      </div>
    );
  }
}
